export const CREATE_FIRM_ENABLER = 'createFirm';
export const DELETE_COMPANY_ENABLER = 'deleteCompany';
export const DELETE_MEASUREMENT_DATES_ENABLER = 'deleteMeasurementDates';
export const DOCUMENTS_ENABLER = 'documents';
export const EXCEL_REPORTS_ENABLER = 'excelReports';
export const PROCESS_MANAGEMENT_ENABLER = 'processManagement';
export const DOCUMENT_GENERATION_JOBS = 'documentGenerationJobs';
export const FUND_INVESTMENTS_ENABLER = 'fundInvestments';
export const DRAWER_EXTRACTION = 'drawerExtraction';
export const SSO_ENABLER = 'singleSignOn';

export const FLAGGED_FEATURE: { key: string; title: string; description: string }[] = [
  {
    key: CREATE_FIRM_ENABLER,
    title: 'Create Firm',
    description: ''
  },
  {
    key: DELETE_COMPANY_ENABLER,
    title: 'Delete Company',
    description: ''
  },
  {
    key: DELETE_MEASUREMENT_DATES_ENABLER,
    title: 'Delete Measurement Dates',
    description: ''
  },
  {
    key: DOCUMENTS_ENABLER,
    title: 'Documents',
    description: ''
  },
  {
    key: EXCEL_REPORTS_ENABLER,
    title: 'Excel Reports',
    description: ''
  },
  {
    key: PROCESS_MANAGEMENT_ENABLER,
    title: 'Process Management',
    description: ''
  },
  {
    key: DOCUMENT_GENERATION_JOBS,
    title: 'Document Generation Jobs',
    description: 'Allows users to create document generation jobs that parses documents and creates a Cap Table using AI.'
  },
  {
    key: FUND_INVESTMENTS_ENABLER,
    title: 'Fund Investments',
    description: ''
  },
  {
    key: DRAWER_EXTRACTION,
    title: 'Drawer Sizing',
    description: 'Sizing testing on the drawer.'
  },
  {
    key: SSO_ENABLER,
    title: 'Single Sign-On (SSO)',
    description: 'Enables Single Sign-On (SSO) functionality for firms using an identity provider.'
  }
]
